import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PowerBIMenuService {
  private exportReportSource = new Subject<void>();
  private openRefreshScheduleSource = new Subject<void>();
  private downloadDataSource = new Subject<void>();
  private tenantDomainSource = new BehaviorSubject<string>('');
  private selectDashboardSource = new BehaviorSubject<string>('Operational');
  private openPowerBiSettingsSource = new Subject<void>();

  exportReport$ = this.exportReportSource.asObservable();
  openRefreshSchedule$ = this.openRefreshScheduleSource.asObservable();
  downloadData$ = this.downloadDataSource.asObservable();
  tenantDomain$ = this.tenantDomainSource.asObservable();
  selectDashboard$ = this.selectDashboardSource.asObservable();
  openPowerBiSettings$ = this.openPowerBiSettingsSource.asObservable();

  triggerExport(): void {
    this.exportReportSource.next();
  }

  triggerRefreshSchedule(): void {
    this.openRefreshScheduleSource.next();
  }

  triggerDownloadData(): void {
    this.downloadDataSource.next();
  }

  setTenantDomain(domain: string): void {
    this.tenantDomainSource.next(domain);
  }

  selectDashboard(dashboardType: string): void {
    this.selectDashboardSource.next(dashboardType);
  }

  triggerPowerBiSettings(): void {
    this.openPowerBiSettingsSource.next();
  }
}
